var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeeth33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 68,
    viewBox: "0 0 42 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_2777_3293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.543 66.4924C12.7398 69.5929 5.02324 61.8417 5.02324 47.1145C5.02324 32.3873 4.25158 22.3108 7.33821 17.6601C10.4248 13.0094 18.913 7.58353 23.543 8.35865C28.1729 9.13376 34.3462 10.684 36.6612 16.8849C38.9761 27.7366 38.2045 62.6168 23.543 66.4924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5174 66.3957L23.5154 66.3963C18.1442 67.9378 13.5542 66.7803 10.3038 63.4193C7.04873 60.0535 5.12324 54.4632 5.12324 47.1145C5.12324 44.5077 5.0991 42.0478 5.07643 39.7384C5.03503 35.5201 4.99856 31.8041 5.12316 28.6125C5.31612 23.6699 5.89544 20.0148 7.42153 17.7154C8.95395 15.4064 11.8345 12.8966 14.9131 11.0606C16.4514 10.1431 18.0358 9.39583 19.5219 8.92634C21.0094 8.4564 22.3908 8.26715 23.5265 8.45727C28.1565 9.23241 34.2696 10.7757 36.5649 16.913C37.7181 22.3272 38.1034 33.7419 36.3696 44.2885C35.5024 49.5635 34.1061 54.6143 32.0151 58.5857C29.9237 62.5577 27.1448 65.4369 23.5174 66.3957Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2777_3293",
    x: 0.9375,
    y: 0.28418,
    width: 40.7109,
    height: 66.8848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2777_3293"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2777_3293",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeth33);
export default __webpack_public_path__ + "static/media/teeth33.9780df745ea8d61b65b31932ffe261ed.svg";
export { ForwardRef as ReactComponent };